import auth, { INewUser } from '../services/auth';
import constants from '../constants/auth';
import { getRecaptcha } from '../services/recaptcha';
import redirect from './redirect';
import routing from '../services/routing';
import routes from '../constants/routes';
import { EMAIL_VERIFICATION_REQUIRED } from '../constants/actions';

export default async (form: INewUser) => {
    const token = await getRecaptcha().execute();
    try {
        const res = await auth.signUp({
            ...form,
            recaptcha: constants.RECAPTCHA_ENABLED !== 'false',
            token,
        });
        getRecaptcha().unmount();
        redirect(res.data);
    } catch (error) {
        if (error instanceof Error && error.message === EMAIL_VERIFICATION_REQUIRED) {
            routing.push(routes.SIGN_UP_COMPLETE_EMAIL, {
                username: encodeURIComponent(form.username),
            });
        } else {
            throw error;
        }
    }
};
